import { render } from "./AppToast.vue?vue&type=template&id=31d2b970&ts=true"
import script from "./AppToast.vue?vue&type=script&lang=ts"
export * from "./AppToast.vue?vue&type=script&lang=ts"

import exportComponent from "/home/mateusz/Workspace/Planer Ślubu/planer-slubu-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__